"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Camera, Video, Thermometer } from "lucide-react";
export default function CoreServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const services = [{
    id: 1,
    icon: Camera,
    title: "Aerial Photography",
    description: "High-resolution imagery from advanced drone cameras"
  }, {
    id: 2,
    icon: Video,
    title: "Video Capture",
    description: "Cinematic aerial video for any project"
  }, {
    id: 3,
    icon: Thermometer,
    title: "Thermal Imaging",
    description: "FLIR-powered thermal camera for inspections"
  }];
  return <section ref={ref} className={`py-20 bg-background transition-opacity duration-[var(--duration-fast)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="container mx-auto px-6">
        {}
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground mb-4">
            See Our Drone Services in Action
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Experience the precision and capability of our advanced drone technology through live aerial footage and comprehensive service offerings
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="relative h-[600px] overflow-hidden rounded-xl shadow-strong border border-border">
            <video autoPlay loop muted playsInline className="absolute inset-0 h-full w-full object-cover">https://centexdrone.com/wp-content/uploads/2026/01/Drone-in-Flight.mp4</video>
            
            {}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-dark-background/90 to-transparent p-6">
              <p className="text-foreground-dark text-sm font-medium">
                Live Drone Operations • Central Texas & DFW Metroplex
              </p>
            </div>
          </div>

          {}
          <div className="space-y-6">
            {services.map((service, i) => {
            const IconComponent = service.icon;
            return <Card key={service.id} data-index={i} className="group relative overflow-hidden rounded-lg border border-border bg-card shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-1 hover:shadow-medium hover:bg-card/95">
                  <CardHeader>
                    <div className="flex items-start gap-4">
                      <div className="mt-1 flex size-12 shrink-0 items-center justify-center rounded-md bg-primary text-foreground-primary shadow-soft">
                        <IconComponent className="size-6" strokeWidth={1.5} />
                      </div>
                      <div className="flex-1">
                        <CardTitle className="text-xl text-foreground">
                          {service.title}
                        </CardTitle>
                        <CardDescription className="mt-1.5 text-muted-foreground">
                          {service.description}
                        </CardDescription>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <Link to="#" className="inline-flex items-center gap-2 text-sm font-medium text-primary opacity-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:translate-x-2 group-hover:opacity-100 focus-ring">
                      Learn More
                      <span aria-hidden="true">→</span>
                    </Link>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}